import { render, staticRenderFns } from "./LoginGoogleInit.vue?vue&type=template&id=5e4e7de1&scoped=true&lang=pug"
import script from "./LoginGoogleInit.vue?vue&type=script&lang=js"
export * from "./LoginGoogleInit.vue?vue&type=script&lang=js"
import style0 from "./LoginGoogleInit.vue?vue&type=style&index=0&id=5e4e7de1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e7de1",
  null
  
)

export default component.exports